import type { U3141PlanUploadTokenMintRequest } from "../../../U3141Service";

export interface U3141MintPlanUploadTokenSuccessPayload {
  accessToken: string;
  expiresAt: string;
  clientRequestUuid: string;
}

export interface U3141UseMintPlanUploadTokenHandlersParams {
  doMintPlanUploadTokenFn: (
    masterLotChainId: string,
    body: U3141PlanUploadTokenMintRequest
  ) => Promise<{ data: Record<string, unknown> }>;
  onSuccess?: (payload: U3141MintPlanUploadTokenSuccessPayload) => void;
  onError?: (errors: { error: unknown }) => void;
}

export interface U3141UseMintPlanUploadTokenHandlersReturn {
  mintPlanUploadToken: (masterLotChainId: string, clientRequestUuid: string) => Promise<void>;
}

/** Valide le format UUID attendu par le backend (clientRequestUuid). */
export function u3141IsClientRequestUuid(value: string): boolean {
  const trimmed = value.trim();
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(trimmed);
}

export function useU3141MintPlanUploadTokenHandlers({
  doMintPlanUploadTokenFn,
  onSuccess,
  onError,
}: U3141UseMintPlanUploadTokenHandlersParams): U3141UseMintPlanUploadTokenHandlersReturn {
  const mintPlanUploadToken = async (masterLotChainId: string, clientRequestUuid: string) => {
    const uuid = clientRequestUuid.trim();
    try {
      const response = await doMintPlanUploadTokenFn(masterLotChainId, { clientRequestUuid: uuid });
      const data = response?.data as Record<string, unknown> | undefined;
      const result = (data?.result ?? data) as Record<string, unknown> | undefined;
      const accessToken = typeof result?.accessToken === "string" ? result.accessToken : "";
      const expiresAt = typeof result?.expiresAt === "string" ? result.expiresAt : "";
      if (!accessToken) {
        onError?.({ error: new Error("Réponse mint jeton : accessToken manquant.") });
        return;
      }
      onSuccess?.({ accessToken, expiresAt, clientRequestUuid: uuid });
    } catch (error) {
      onError?.({ error });
    }
  };

  return { mintPlanUploadToken };
}
